import PageHeader from "../content/page/PageHeader"
import PageBuilder from "../content/PageBuilder"

interface ServiceDefaultProps {
	service: any
	dynamicData: any
}


const ServiceDefault = (props: ServiceDefaultProps) => {

	const { service, dynamicData } = props

	return (
		<>
			<PageHeader page={service} />
			<PageBuilder contentBlocks={service.pageBuilder} dynamicData={dynamicData} />
		</>
	)

}
export default ServiceDefault
